<section class="offshore" id="offshore">
  <!-- Background decor -->
  <div class="offshore__grid"></div>
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>

  <div class="container">
    <div class="offshore__header">
      <span class="section-tag">{{ t().offshore_tag }}</span>
      <h2 class="section-title">{{ t().offshore_title }}<br><span>{{ t().offshore_subtitle }}</span></h2>
    </div>

    <!-- Vessel types -->
    <div class="offshore__vessels">
      <span class="offshore__vessels-label">Designed for:</span>
      <div class="vessel-chips">
        <span class="vessel-chip" *ngFor="let v of vessels()">{{ v.name }}</span>
      </div>
    </div>

    <!-- Detections grid -->
    <div class="offshore__detections">
      <h3 class="offshore__detections-title">Supported detections</h3>
      <div class="detections-grid">
        <div class="detection-item" *ngFor="let d of detections()">
          <span class="detection-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M9 12l2 2 4-4" stroke="#22c55e" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </span>
          <span>{{ d }}</span>
        </div>
      </div>
    </div>

    <!-- Ship illustration -->
    <div class="offshore__illustration">
      <div class="ship-container">
        <!-- Vessel SVG outline -->
        <svg viewBox="0 0 400 200" fill="none" xmlns="http://www.w3.org/2000/svg" class="ship-silhouette">
          <!-- Hull -->
          <path d="M20 160 L60 120 L340 120 L380 160 L20 160Z" stroke="rgba(0,102,204,0.3)" stroke-width="2" fill="rgba(0,102,204,0.08)"/>
          <!-- Deck -->
          <rect x="80" y="80" width="240" height="40" rx="2" stroke="rgba(0,102,204,0.3)" stroke-width="1.5" fill="rgba(0,102,204,0.05)"/>
          <!-- Bridge -->
          <rect x="180" y="50" width="60" height="30" rx="2" stroke="rgba(0,102,204,0.3)" stroke-width="1.5" fill="rgba(0,102,204,0.08)"/>
          <!-- Cranes -->
          <path d="M130 80 L130 40 L150 40 M270 80 L270 40 L290 40" stroke="rgba(0,102,204,0.4)" stroke-width="2" fill="none"/>
          <!-- Helideck circle -->
          <circle cx="200" cy="60" r="12" stroke="rgba(0,212,255,0.4)" stroke-width="2" fill="none"/>
          <circle cx="200" cy="60" r="8" stroke="rgba(0,212,255,0.3)" stroke-width="1" fill="none" stroke-dasharray="4 2"/>
          <!-- Detection zones (animated scan lines) -->
          <rect x="80" y="80" width="240" height="40" rx="2" class="scan-zone" stroke="rgba(0,212,255,0.2)" stroke-width="1" fill="none"/>
          <!-- Radar waves from bridge -->
          <path d="M200 50 Q210 30 200 10 M200 50 Q220 30 220 10 M200 50 Q230 30 240 10" stroke="rgba(0,212,255,0.3)" stroke-width="1.5" fill="none" class="radar-wave"/>
          <!-- Camera dots -->
          <circle cx="100" cy="75" r="3" fill="#22c55e" class="camera-dot"/>
          <circle cx="160" cy="75" r="3" fill="#22c55e" class="camera-dot"/>
          <circle cx="240" cy="75" r="3" fill="#22c55e" class="camera-dot"/>
          <circle cx="300" cy="75" r="3" fill="#22c55e" class="camera-dot"/>
          <!-- Water waves -->
          <path d="M0 170 Q50 163 100 170 Q150 177 200 170 Q250 163 300 170 Q350 177 400 170" stroke="rgba(0,212,255,0.2)" stroke-width="1.5" fill="none" class="water-wave"/>
          <path d="M0 180 Q50 175 100 180 Q150 185 200 180 Q250 175 300 180 Q350 185 400 180" stroke="rgba(0,212,255,0.1)" stroke-width="1" fill="none" class="water-wave wave-2"/>
        </svg>
      </div>
    </div>
  </div>
</section>